/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The surviving source a merged-away source now points at.
 * @export
 * @interface MergedIntoHistoryEntrySource
 */
export interface MergedIntoHistoryEntrySource {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the MergedIntoHistoryEntrySource interface.
 */
export function instanceOfMergedIntoHistoryEntrySource(value: object): value is MergedIntoHistoryEntrySource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function MergedIntoHistoryEntrySourceFromJSON(json: any): MergedIntoHistoryEntrySource {
    return MergedIntoHistoryEntrySourceFromJSONTyped(json, false);
}

export function MergedIntoHistoryEntrySourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergedIntoHistoryEntrySource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function MergedIntoHistoryEntrySourceToJSON(json: any): MergedIntoHistoryEntrySource {
    return MergedIntoHistoryEntrySourceToJSONTyped(json, false);
}

export function MergedIntoHistoryEntrySourceToJSONTyped(value?: MergedIntoHistoryEntrySource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

